<template>
  <div v-if="post.PostTagLists && post.PostTagLists[0].PostTagUserID" class="d-block">
    <div class="d-block">
      <K2Icon name="file_download" @onclick="() => generatePostPDF(post)" :link="true" />
    </div>
  </div>
</template>

<script>
import K2Icon from '@/uiComponents/k2Icon/k2MAIcon'
import DataSource from '@/data/datasource'
import { getBase } from '@/helper/util_custom'
import axios from 'axios'
import html2pdf from 'html2pdf.js'
import { constDateFormat, getFormatDate } from '@/helper/utily'

export default {
  name: 'K2PrintFromURL',
  components: { K2Icon },
  props: ['post'],
  data() {
    return {
      items: ['Item 1', 'Item 2', 'Item 3'],
    }
  },
  methods: {
    async generatePostPDF(post) {
      if (post) {
        if (post.PostUpdDtlContent2 !== 'null' && post.PostUpdDtlContent2 !== '') {
          post.content2Title = 'Observation'
        } else {
          post.PostUpdDtlContent2 = ''
        }
        if (post.PostUpdDtlContent3 !== 'null' && post.PostUpdDtlContent3 !== '') {
          post.content3Title = 'Literacy'
        } else {
          post.PostUpdDtlContent3 = ''
        }
        if (post.PostUpdDtlContent4 !== 'null' && post.PostUpdDtlContent4 !== '') {
          post.content4Title = 'Numeracy'
        } else {
          post.PostUpdDtlContent4 = ''
        }

        const iframe = document.createElement('iframe')
        iframe.style.position = 'absolute'
        iframe.style.left = '-9999px'
        iframe.style.top = '-9999px'
        document.body.appendChild(iframe)
        const {
          PostUpdDtlTitle,
          PostTagLists,
          PostCreatedDate,
          CONname,
          PostUpdDtlContent1,
          PostUpdDtlContent2,
          PostUpdDtlContent3,
          PostUpdDtlContent4,
          PostLearningMomentsGrouping,
          PostItems,
          content2Title,
          content3Title,
          content4Title,
        } = this.post || {}
        const doc = iframe.contentWindow.document
        doc.open()
        doc.write(`
        <html>
          <head>
            <title>${PostTagLists?.[0]?.StudentName}</title>
            <style>
              body { font-family: Arial, sans-serif;word-break: break-word; background-color: #ffffff } h1, p, ul, li { color: #333; page-break-inside: avoid; } h1 { font-size: 24px; } p { font-size: 14px; } .image-container { page-break-inside: avoid; /* Prevent breaking inside the image container */ break-inside: avoid; text-align: center; /* Center image if needed */ } img { max-width: 100%; height: auto;  /* Maintain aspect ratio */ page-break-before: auto; page-break-after: auto; page-break-inside: avoid;  /* Prevent page break inside the image */ } .page-break { page-break-before: always; }
            </style>
          </head>
          <body style="background-color: white">
          <div style="padding:10px">
            <h1 style="color:#d64b58; border-bottom: 10px solid #d64b58;padding-bottom: 10px">${PostTagLists?.[0]?.StudentName}</h1>
            <h3 style="text-align: center">Our Vision</h3>
            <p style="text-align: center">Shaping the future through education</p>
            <h3 style="text-align: center">Our Mission</h3>
            <p style="text-align: center">Developing confident and capable global citizens</p>
            <p> Our mission as a community of educators is to empower your child to become a curious and engaged life-long learner, and a confident and capable global citizen.<br/> As an international school group, we want to lead rather than follow education systems that skew towards grades and tests. Our vision is to help shape the future through holistic programmes that integrate inter and intra-personal development, skills, and academia. </p>
            <p>${PostUpdDtlTitle} ${getFormatDate(PostCreatedDate, constDateFormat.shortMonthLabel)} - ${CONname}</p>
            <img width="150" src="${PostItems?.[0]?.FilePath}"/>
            <p>${PostUpdDtlContent1}</p>
            <strong>${content2Title || ''}</strong>
            <p>${PostUpdDtlContent2 || ''}</p>
            <strong>${content4Title || ''}</strong>
            <p>${PostUpdDtlContent4 || ''}</p>
            <strong>${content3Title || ''}</strong>
            <p>${PostUpdDtlContent3 || ''}</p>
            <strong>Analysis</strong>
            <ul> ${PostLearningMomentsGrouping.map(item => ` <li> ${item?.Domain} <ul> ${item?.ItemList?.map(goal => `<li>${goal?.PostUpLMGoals}<br/>${goal?.PostUpLMIndicator}</li>`).join('')} </ul> </li> `).join('')} </ul>
           <div>
           <div class="image-container" >
           ${PostItems.map(media => `<img width="150" src="${media.FilePath}"/>`).join('')}
           </div>
           </div>
          </div>
          </body>
        </html>
      `)
        doc.close()

        iframe.onload = () => {
          const iframeDocument = iframe.contentWindow.document

          const options = {
            margin: 0.5,
            filename: PostUpdDtlTitle + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 5, useCORS: true },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
            pagebreak: {
              mode: ['avoid-all', 'css', 'legacy'],
            },
          }

          html2pdf()
            .set(options)
            .from(iframeDocument.body)
            .save()
            .finally(() => {
              document.body.removeChild(iframe)
            })
        }
      }
    },
    async getPostDownloadURL() {
      this.$vs.loading()

      let downloadURL = await this.downloadSinglePost()
      try {
        const response = await axios.get(downloadURL)
        if (response.data) {
          let element = response.data
          const opt = {
            margin: 40,
            filename: this.post?.PostUpdDtlTitle + '.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            manualPagination: true,
            html2canvas: { scale: 5, useCORS: true, width: 430 },
            jsPDF: { unit: 'px', format: 'a4', orientation: 'portrait', hotfixes: ['px_scaling'] },
            pagebreak: { before: '.beforeClass', after: ['#after1', '#after2'], avoid: 'img' },
          }
          let instance = html2pdf().from(element).set(opt)
          instance.save()
          instance.reset()
        } else {
          console.error('Error generating PDF: Empty response from the server')
        }
      } catch (error) {
        console.error('Error generating PDF:', error)
      }
      this.$vs.loading.close()
    },
    async downloadSinglePost() {
      try {
        const response = await DataSource.shared.generatePostPDF(this.post?.PostID, this.post?.PostTagLists?.[0]?.PostTagUserID)
        if (response) {
          let fileName = response?.[0]
          let base = getBase()
          return `${base}/blobs/posts/${fileName}`
        }
      } catch (e) {
        console.log(e, 'downloadSinglePost err')
      }
    },
  },
}
</script>
